<template>
    <v-card :class="['cs-card', cssClass]" :elevation="elevation" :loading="loading" flat>
        <div class="cs-head" :class="{ pointer: expandable }" @click="toggleExpand()">
            <span class="cs-ic"><v-icon small>{{ icon }}</v-icon></span>
            <span class="cs-title">{{ title }}</span>
            <span v-if="enableBadge" class="cs-badge" :class="{ 'is-zero': badgeValue === '0' }">{{ badgeValue }}</span>
            <span class="cs-spacer"></span>
            <div class="cs-actions">
                <slot name="actions" />
                <template v-if="expandable">
                    <v-icon class="cs-chev" :class="{ 'is-open': expanded }">mdi-chevron-down</v-icon>
                </template>
            </div>
        </div>
        <v-expand-transition>
            <div v-show="expanded" class="cs-body">
                <slot />
            </div>
        </v-expand-transition>
    </v-card>
</template>
<script>
    export default {

        props: {

            loading: {
                type: Boolean,
                default: false
            },

            title: {
                type: String,
                default: ''
            },

            icon: {
                type: String,
                default: 'mdi-comment-text-multiple-outline'
            },

            cssClass: {
                type: String,
                default: 'mb-4'
            },

            expandable: {
                type: Boolean,
                default: false
            },

            enableBadge: {
                type: Boolean,
                default: false
            },

            badgeValue: {
                type: String,
                default: ''
            },

            isExpanded: {
                type: Boolean,
                default: true
            },

            elevation: {
                type: Number,
                default: 0
            }
        },

        data() {
            return {
                expanded: this.isExpanded
            }
        },

        methods: {

            toggleExpand() {
                if (this.expandable) {
                    this.expanded = !this.expanded
                }
            }

        }
    }
</script>
<style scoped>
    .cs-card {
        border: 1px solid #e6ecea !important;
        border-radius: 18px !important;
        box-shadow: 0 1px 2px rgba(15, 23, 42, .04), 0 8px 24px -16px rgba(15, 23, 42, .18) !important;
        overflow: hidden;
    }

    .cs-head {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 12px 18px;
        border-bottom: 1px solid #e6ecea;
        color: #1f2a28;
    }

    .cs-ic {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 32px;
        width: 32px;
        height: 32px;
        border-radius: 10px;
        background: #e6f2f1;
    }
    .cs-ic .v-icon { color: #0a716e !important; }

    .cs-title { font-size: 15px; font-weight: 800; }

    .cs-badge {
        min-width: 22px;
        height: 22px;
        padding: 0 7px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 999px;
        background: #0a716e;
        color: #fff;
        font-size: 11.5px;
        font-weight: 700;
    }
    .cs-badge.is-zero { background: #e6ecea; color: #6b7a77; }

    .cs-spacer { flex: 1 1 auto; }

    .cs-actions { display: flex; align-items: center; gap: 4px; }

    .cs-chev {
        color: #6b7a77 !important;
        transition: transform .25s cubic-bezier(.2, .8, .2, 1);
    }
    .cs-chev.is-open { transform: rotate(180deg); }

    .cs-body { padding: 4px 0 0; }

    .pointer { cursor: pointer; }
</style>
